import { render, staticRenderFns } from "./cus_footer_sec.vue?vue&type=template&id=e9b56140&scoped=true"
import script from "./cus_footer_sec.vue?vue&type=script&lang=js"
export * from "./cus_footer_sec.vue?vue&type=script&lang=js"
import style0 from "./cus_footer_sec.vue?vue&type=style&index=0&id=e9b56140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b56140",
  null
  
)

export default component.exports